import { withNamespaces } from "react-i18next";
import useSupplierOverviewEudrComplianceCheck from "./hooks/useSupplierOverviewEudrComplianceCheck";
import { useCallback, useMemo } from "react";
import BootstrapTable from 'react-bootstrap-table-next';
import {
    MAIN_HEADER_STYLE
} from './constants/tableStyles';
import { Card, CardBody, CardTitle } from "reactstrap";
import RedFlagIcon from 'src/modules/3rd-party-management/components/RedFlagIcon';
import EvidenceSource from "./components/EvidenceSource";
import TaskStatus from "./components/TaskStatus";

const EudrComplianceCheckSkeleton = () => (
    <Card className="overview-eudr-compliance-check h-100 mb-0">
        <CardBody>
            <div className="dt-field dt-skeleton mb-4" style={{ width: '25%' }} />
            <div className="dt-field dt-skeleton" style={{ width: '100%', height: '280px' }} />
        </CardBody>
    </Card>
);

const formatFlag = (cell) => (
    <RedFlagIcon isFlagged={!!cell} />
);

const formatEvidenceSource = (cell) => (
    <EvidenceSource source={cell} />
)

const formatTaskStatus = (cell) => (
    <TaskStatus status={cell} />
)

const formatArticles = (cell) => (
    <span>{cell?.join(', ')}</span>
);

const EudrComplianceCheck = ({
    t,
    supplierId,
}) => {
    const fetchEudrComplianceCheckQuery = useSupplierOverviewEudrComplianceCheck({
        supplierId,
        t,
    });

    const {
        checks = []
    } = fetchEudrComplianceCheckQuery.data || {};

    const columns = useMemo(() => [
        {
            dataField: 'id',
            text: '#',
            headerStyle: MAIN_HEADER_STYLE,
        },
        {
            dataField: 'requirement',
            text: t('EUDR Requirement'),
            headerStyle: MAIN_HEADER_STYLE,
        },
        {
            dataField: 'articles',
            text: t('Article'),
            headerStyle: MAIN_HEADER_STYLE,
            formatter: formatArticles,
        },
        {
            dataField: 'redFlag',
            text: t('Red Flags'),
            headerStyle: MAIN_HEADER_STYLE,
            formatter: formatFlag,
        },
        {
            dataField: 'evidenceSource',
            text: t('Evidence Source'),
            headerStyle: MAIN_HEADER_STYLE,
            formatter: formatEvidenceSource,
        },
        {
            dataField: 'actionNeeded',
            text: t('Action Needed'),
            headerStyle: MAIN_HEADER_STYLE,
        },
        {
            dataField: 'taskStatus',
            text: t('Task Status'),
            headerStyle: MAIN_HEADER_STYLE,
            formatter: formatTaskStatus,
        },
    ], [t]);

    const noDataIndication = useCallback(() => (
        <div className="text-center py-4 text-muted">
            {t('No data available.')}
        </div>
    ), [t]);

    if (fetchEudrComplianceCheckQuery.isLoading || fetchEudrComplianceCheckQuery.isFetching) {
        return <EudrComplianceCheckSkeleton />;
    }

    return (
        <Card className="overview-eudr-compliance-check h-100 mb-0">
            <CardBody>
                <CardTitle tag="h6" className="overview-section-title mb-4">
                    {t('EUDR Compliance Check')}
                </CardTitle>

                <div className="table-responsive">
                    <BootstrapTable
                        keyField="id"
                        data={checks}
                        columns={columns}
                        bordered={false}
                        striped={false}
                        hover={false}
                        classes="table align-middle mb-0"
                        noDataIndication={noDataIndication}
                    />
                </div>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(EudrComplianceCheck);